module.exports = __webpack_public_path__ + "static/media/inventorymanager.1c4fef76.png";